
import React, { Component } from 'react';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import ErrorMessage from './cmpErrorMessage'



function draw(that) {
  const canvas = that.canvas ? that.canvas.current : undefined;

  const fontName = 'Bookman';
  const nFontName = 'Verdana';
  const fontSize = 3.8;
  const nFontSize = 3.2;
  const scaleBars = that.scaleBars || 1;

  if (canvas) {
    // Double the resolution, to get a better quality
    canvas.style.width = that.width + 'px';
    canvas.style.height = that.height + 'px';
    canvas.width = Math.ceil(that.width * 2);
    canvas.height = Math.ceil(that.height * 2);
    var ctx = canvas.getContext('2d');
    const scaleX = that.scaleX || 1;
    ctx.scale(2 / scaleX, 2);

    // Setup font and the coordinate system (lower-left=0,0, upper-right=100,100)
    ctx.save();
    ctx.rect(that.x0, that.y0, that.width, that.height);
    ctx.clip();
    ctx.transform((that.width - that.x0) / 100, 0, 0, -(that.height - that.y0) / 100, that.x0, that.height);
    ctx.lineWidth = 100.0 / that.width;
    ctx.font = fontSize + 'px ' + fontName;
  }

  const rectX0 = 5;
  const rectY0 = 22;
  // const rectX1 = 99.5;
  const rectY1 = 99.5;

  const barWidth = 3.6;
  const barSep = 1.3;
  var x = rectX0 + barWidth;
  var maxStrataHeight = 0;

  const addHorizontalText = (text, x, y) => {
    if (canvas) {
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(1, -1)
      ctx.fillText(text, 0, 0);
      ctx.restore();
    }
  }

  const addVerticalText = (text, x, y) => {
    if (canvas) {
      ctx.save();
      ctx.translate(x, y);
      ctx.scale(-1, 1)
      ctx.rotate(Math.PI / 2);
      ctx.fillText(text, 0, 0);
      ctx.restore();
    }
  }

  const time2str = (seconds) => {
    return seconds.toFixed(1) + 's';
  }

  const sampleCount2str = (count) => {
    if (count <= 999) return count.toFixed(0);
    return (count / 1000.0).toFixed(1) + 'k';
  }

  const value2str = (val) => {
    return that.kind === 'times' ? time2str(val) : sampleCount2str(val);
  }

  var highestBar = 0;
  const addBar = (name, value, err) => {
    const height = typeof (value) === 'number' ? value * scaleBars : value;
    const err2 = 1.96 * err * scaleBars;
    if (canvas) {
      ctx.save();
      if (typeof (value) === 'number') {
        ctx.lineWidth = ctx.lineWidth * 1.2;
        ctx.fillRect(x - barWidth / 2, rectY0, barWidth, height);
        ctx.strokeRect(x - barWidth / 2, rectY0, barWidth, height);
        if (err) {
          ctx.beginPath();
          ctx.moveTo(x - barWidth / 4, rectY0 + height + err2);
          ctx.lineTo(x + barWidth / 4, rectY0 + height + err2);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x - barWidth / 4, rectY0 + height - err2);
          ctx.lineTo(x + barWidth / 4, rectY0 + height - err2);
          ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(x, rectY0 + height + err2);
          ctx.lineTo(x, rectY0 + height - err2);
          ctx.stroke();
        }
      } else {
        ctx.save();
        ctx.translate(x, rectY0);
        ctx.scale(-1, 1);
        ctx.rotate(Math.PI / 2);
        ctx.font = 'bold ' + (fontSize * 0.9) + 'px ' + fontName;
        ctx.fillStyle = 'rgb(153,67,62)';
        ctx.textAlign = 'start';
        ctx.textBaseline = 'middle';
        ctx.fillText(value, 0.5, 0);
        ctx.restore();
      }
      if (typeof (value) === 'number') {
        ctx.save();
        ctx.translate(x, rectY0 + height + (err2 ? err2 : 0));
        ctx.scale(-1, 1);
        ctx.rotate(Math.PI / 2);
        ctx.font = (nFontSize * 0.95) + 'px ' + nFontName;
        ctx.fillStyle = '#000000';
        ctx.textAlign = 'start';
        ctx.textBaseline = 'middle';
        const valStr = value2str(value);
        ctx.fillText(valStr, 0.5, 0);
        highestBar = Math.max(ctx.measureText(valStr).width + height + (err2 ? err2 : 0), highestBar);
        ctx.restore();
      }
      ctx.translate(x, rectY0);
      ctx.scale(-1, 1);
      ctx.rotate(Math.PI / 2);
      ctx.fillStyle = '#000000';
      ctx.textAlign = 'end';
      ctx.textBaseline = 'middle';
      if (name.includes('^')) {
        const parts = name.split('^', 2);
        const base = parts[0];
        const power = parts[1];
        ctx.font = (nFontSize * 0.85) + 'px ' + nFontName;
        ctx.fillText(power, -0.5, -0.4);
        var w = ctx.measureText(power).width + 0.5;
        ctx.font = nFontSize + 'px ' + nFontName;
        ctx.fillText(base, -0.6 - w, 0.6);
        w += ctx.measureText(base).width + 0.6;
        maxStrataHeight = Math.max(maxStrataHeight, w)
      } else
        ctx.fillText(name, -0.5, 0);
      ctx.restore();
    }
    x += barWidth + 0.75;
  }

  if (canvas) {
    ctx.fillStyle = 'rgb(165,198,194)';
    ctx.strokeStyle = 'rgb(105,159,152)';
  }
  if (that.data.MTBDD) addBar('MTBDD', that.data.MTBDD);
  if (that.data.Sparse) addBar('Sparse', that.data.Sparse);
  if (that.data.Hybrid) addBar('Hybrid', that.data.Hybrid);
  if (that.data.Explicit) addBar('Explicit', that.data.Explicit);

  if (that.data.MTBDD || that.data.Sparse || that.data.Hybrid || that.data.Explicit)
    x += barSep;

  if (canvas) {
    ctx.fillStyle = 'rgb(148,149,196)';
    ctx.strokeStyle = 'rgb(96,98,166)';
  }
  if (that.data.SPRT) addBar('SPRT', that.data.SPRT[0], that.data.SPRT[1]);

  if (canvas) {
    ctx.fillStyle = 'rgb(158,164,169)';
    ctx.strokeStyle = 'rgb(120,129,136)';
  }
  if (that.data.GLRT) addBar('GLRT', that.data.GLRT[0], that.data.GLRT[1]);

  if (canvas) {
    ctx.fillStyle = 'rgb(186,162,148)';
    ctx.strokeStyle = 'rgb(163,132,114)';
  }
  if (that.data.Antithetic) addBar('Antithetic', that.data.Antithetic[0], that.data.Antithetic[1]);

  if (that.data.SPRT || that.data.GLRT || that.data.Antithetic)
    x += barSep;

  const addStrataBarIfDefined = (key) => {
    if (!that.data[key]) return false;
    addBar(key.substring(2), that.data[key][0], that.data[key][1]);
    return true;
  }

  var hasStrata2 = false
  var hasStrata16 = false
  var hasStrata256 = false
  var hasStrata4096 = false

  const straXbegin = x;
  if (canvas) {
    ctx.fillStyle = 'rgb(192,139,191)';
    ctx.strokeStyle = 'rgb(168,101,167)';
  }
  const straX2begin = x;
  hasStrata2 |= addStrataBarIfDefined('S-2^1');
  const straX2end = x;

  if (hasStrata2)
    x += barSep / 2;

  if (canvas) {
    ctx.fillStyle = 'rgb(173,197,161)';
    ctx.strokeStyle = 'rgb(132,168,115)';
  }
  const straX16begin = x;
  hasStrata16 |= addStrataBarIfDefined('S-2^4');
  hasStrata16 |= addStrataBarIfDefined('S-4^2');
  hasStrata16 |= addStrataBarIfDefined('S-16^1');
  const straX16end = x;

  if (hasStrata16)
    x += barSep / 2;

  if (canvas) {
    ctx.fillStyle = 'rgb(163,186,222)';
    ctx.strokeStyle = 'rgb(106,143,202)';
  }
  const straX256begin = x;
  hasStrata256 |= addStrataBarIfDefined('S-2^8');
  hasStrata256 |= addStrataBarIfDefined('S-4^4');
  hasStrata256 |= addStrataBarIfDefined('S-16^2');
  hasStrata256 |= addStrataBarIfDefined('S-256^1');
  const straX256end = x;

  if (hasStrata256)
    x += barSep / 2;

  if (canvas) {
    ctx.fillStyle = 'rgb(211,148,148)';
    ctx.strokeStyle = 'rgb(189,97,99)';
  }
  const straX4096begin = x;
  hasStrata4096 = addStrataBarIfDefined('S-2^12');
  hasStrata4096 = addStrataBarIfDefined('S-4^6');
  hasStrata4096 = addStrataBarIfDefined('S-16^3');
  hasStrata4096 = addStrataBarIfDefined('S-64^2');
  hasStrata4096 = addStrataBarIfDefined('S-4096^1');
  const straX4096end = x;

  if (hasStrata4096)
    x += barSep / 2;

  const straXend = x;

  if (canvas) {
    ctx.fillStyle = '#000000'
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.font = nFontSize + 'px ' + nFontName;
  }
  if (hasStrata2) addHorizontalText('2', (straX2begin + straX2end - barWidth - 1) / 2, rectY0 - maxStrataHeight - 1.2 * nFontSize / 2);
  if (hasStrata16) addHorizontalText('16', (straX16begin + straX16end - barWidth - 1) / 2, rectY0 - maxStrataHeight - 1.2 * nFontSize / 2);
  if (hasStrata256) addHorizontalText('256', (straX256begin + straX256end - barWidth - 1) / 2, rectY0 - maxStrataHeight - 1.2 * nFontSize / 2);
  if (hasStrata4096) addHorizontalText('4096', (straX4096begin + straX4096end - barWidth - 1) / 2, rectY0 - maxStrataHeight - 1.2 * nFontSize / 2);

  if (canvas) {
    ctx.font = fontSize + 'px ' + fontName;
  }
  if (hasStrata2 || hasStrata16 || hasStrata256 || hasStrata4096)
    addHorizontalText('Stratified', (straXbegin + straXend - barWidth - 1) / 2, rectY0 - maxStrataHeight - 1.2 * nFontSize - 1.2 * fontSize / 2);

  if (canvas) {
    ctx.globalCompositeOperation = 'destination-over';
    ctx.strokeStyle = 'rgb(221,221,221)';
    ctx.strokeRect(straXbegin - barWidth + barSep / 2, rectY0, straXend - straXbegin, -maxStrataHeight);
    // ctx.strokeRect(straXbegin - barWidth + barSep / 2, rectY0, straXend - straXbegin, -maxStrataHeight - nFontSize);
    ctx.strokeRect(straXbegin - barWidth + barSep / 2, rectY0, straXend - straXbegin, -maxStrataHeight - 1.2 * nFontSize - 1.2 * fontSize);
    if (hasStrata2) ctx.strokeRect(straX2begin - barWidth + barSep / 2, rectY0, straX2end - straXbegin + barSep / 2, -maxStrataHeight - 1.2 * nFontSize);
    if (hasStrata16) ctx.strokeRect(straX16begin - barWidth + barSep / 2, rectY0, straX16end - straX16begin + barSep / 2, -maxStrataHeight - 1.2 * nFontSize);
    if (hasStrata256) ctx.strokeRect(straX256begin - barWidth + barSep / 2, rectY0, straX256end - straX256begin + barSep / 2, -maxStrataHeight - 1.2 * nFontSize);
    if (hasStrata4096) ctx.strokeRect(straX4096begin - barWidth + barSep / 2, rectY0, straX4096end - straX4096begin + barSep / 2, -maxStrataHeight - 1.2 * nFontSize);
    ctx.globalCompositeOperation = 'source-over';
  }

  if (canvas) {
    // Draw the big rectangle
    ctx.strokeStyle = '#000000'
    ctx.fillStyle = '#F3F3F3'
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillRect(rectX0, rectY0, straXend - rectX0 - barSep, rectY1 - rectY0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.strokeRect(rectX0, rectY0, straXend - rectX0 - barSep, rectY1 - rectY0);

    ctx.textBaseline = 'bottom';
    ctx.textAlign = 'center';
    ctx.fillStyle = '#000000'
    addVerticalText(that.kind === 'times' ? 'Average Time' : 'Average Number of Samples', rectX0, (rectY0 + rectY1) / 2);

    ctx.restore();
  }

  // straXbegin - barWidth + barSep / 2
  //  straXend - straXbegin, -maxStrataHeight);

  // return canvas ? highestBar / (rectY1 - rectY0) : straXend - rectX0 - barSep + 5.5;
  return canvas ? highestBar / (rectY1 - rectY0) : straXend - barWidth + barSep / 2 + 2;
}

//-------------------------------------------------------------------------------------------------------------------------------------------------------------

class Graph extends Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
    this.kind = props.kind;
    this.data = props.data;
    this.x0 = props.offsetX;
    this.y0 = props.offsetY;
    this.width = props.width
    this.height = props.height;
    this.scaleX = props.scaleX;
    this.scaleBars = this.data.initScaleBar || 0.1;
    this.minScaleBars = 0.001;
    this.animationFrames = 0;
  }

  componentDidMount() {
    if (!this.canvas.current)
      return;
    const that = this;
    function closure() {
      const maxFrames = 100;
      const h = draw(that);
      var needMore = false;
      if (h < 0.95) {
        needMore = true;
        that.animationFrames += 1;
        that.scaleBars *= 1 + (1 - Math.pow(h, 0.3)) / 3;
      }
      else if (h > 1) {
        if (that.minScaleBars > 0) {
          console.warn('scaleBars (' + that.scaleBars + ') is too large. It was originally ' + that.initScaleBars + '. It will be reset to ' + that.minScaleBars);
          needMore = true;
          that.animationFrames += 1;
          that.scaleBars = that.minScaleBars;
          that.minScaleBars = 0;
        }
        else console.error('Could not find the right value for scaleBars. Current value is ' + that.scaleBars + ', initial value was ' + that.initScaleBars);
      }
      if (needMore)
        if (that.animationFrames < maxFrames)
          window.requestAnimationFrame(closure);
        else
          console.warn('Needed to draw more, but maximum number of frames (' + maxFrames + ') are already drawn');
    }
    closure();
  }

  render = () => {
    return <canvas ref={this.canvas} />
  }
}

//-------------------------------------------------------------------------------------------------------------------------------------------------------------

export default class Benchmarks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      address: props.address,
      failedMsg: undefined,
      data: undefined
    };
  }

  componentDidMount() {
    fetch(this.state.address)
      .then(response => {
        if (!response.ok)
          throw Error('./' + response.statusText);
        return response;
      })
      .then((r) => r.json())
      .then(js => {
        this.setState({
          isLoading: false,
          data: js
        })
      })
      .catch(e => this.setState({
        isLoading: false,
        failedMsg: e
      }))
  }

  render = () => {
    if (this.state.failedMsg)
      return (
        <Typography component='div' papers={this.state.papers} style={{ padding: 8 * 3 }}>
          <ErrorMessage msg={'Error in loading file.' + this.state.address} extra={this.state.failedMsg.toString()} />
        </Typography>);
    if (this.state.isLoading)
      return (
        <Typography component='div' papers={this.state.papers} style={{ padding: 8 * 3, width: '100%' }}>
          <Grid container justify='center' alignItems='center'>
            <Grid item><CircularProgress /></Grid>
          </Grid>
        </Typography>);
    const rows = this.state.data.results.map((result, index) => {
      // Make <span/>s for parameters (we don't make string, because we want to add non-breaking space as thousand separator)
      var params = [<span key='p-1'>Parameters:</span>];
      var size = [<span key='s-1'>Size:</span>];
      var first = true;
      for (var k in result.params) {
        params.push((first ? ' ' : ', ') + k + '=' + result.params[k]);
        first = false;
      }
      first = true;
      for (k in result.size) {
        const parts = result.size[k].replace(/\B(?=(\d{3})+(?!\d))/g, '&nbsp;').split('&nbsp;');
        const spaced = parts.map((n, i) => {
          if (i === 0) return n
          return <span key={'sp-' + i}>&#8239;{n}</span>
        });
        size.push(<span key={'s-' + k}>{first ? ' ' : ', '}{k}={spaced}</span>)
        first = false;
      }
      // If only one of 'params' or 'size' contains element or if none of them do then no need to say this is params, that is size
      if (params.length === 1 || size.length === 1) {
        params.shift();
        size.shift();
      }

      const s1 = draw({ kind: 'times', data: result.times }) / 100.0;
      const s2 = draw({ kind: 'samples', data: result.samples }) / 100.0;
      const w1 = s1 * 390.0;
      const w2 = s2 * 390.0;
      var description = result.description ? result.description.trim() : undefined;
      var note = result.note ? result.note.trim() : undefined;

      var appBar = undefined
      if (params.length > 0 || size.length > 0 || note) {
        var info = undefined;
        if (params && size) info = <Typography align='center' variant='caption'>{params}&emsp;&emsp;&emsp;{size}</Typography>;
        else if (params) info = <Typography align='center' variant='caption'>{params}</Typography>;
        else if (size) info = <Typography align='center' variant='caption'>{size}</Typography>;
        appBar = (
          <AppBar position='static' style={{ backgroundColor: 'rgb(32,39,42)' }}>
            {!info ? '' : info}
            {!note ? '' : <Typography align='justify' variant='caption' dangerouslySetInnerHTML={{ __html: note }} />}
          </AppBar>);
      }
      return (
        <Card key={index} style={{ marginTop: index = 0 ? '0px' : '10px', marginBottom: index = this.state.data.results.length ? '0px' : '10px' }}>
          <Grid container justify='space-evenly' >
            {!description ? '' :
              <Grid item key='desc' style={{ flexBasis: '100%' }}>
                <Typography align='justify' variant='body2' color='textPrimary' dangerouslySetInnerHTML={{ __html: description }} />
              </Grid>}
            <Grid item >
              <div style={{ marginLeft: '10pt', marginRight: '10pt', marginTop: '10pt' }}>
                <Graph offsetX={0} offsetY={0} width={w1} height={300} kind='times' data={result.times} scaleX={s1} style={{ lineHeight: 'normal' }} />
              </div>
            </Grid>
            <Grid item>
              <div style={{ marginLeft: '10pt', marginRight: '10pt', marginTop: '10pt' }}>
                <Graph offsetX={0} offsetY={0} width={w2} height={300} kind='samples' data={result.samples} scaleX={s2} style={{ lineHeight: 'normal' }} />
              </div>
            </Grid>
          </Grid>
          {!appBar ? '' : appBar}
        </Card>
      );
    });
    var description = this.state.data.description ? this.state.data.description.trim() : undefined;
    const cells = rows.map((row, index) => {
      return <Grid item key={index} zeroMinWidth={true}>{row}</Grid>;
    });
    if (description)
      cells.unshift(
        <Grid item xs={12} key='desc' zeroMinWidth={true}>
          <Typography align='justify' variant='body2' color='textPrimary' dangerouslySetInnerHTML={{ __html: description }} />
        </Grid>);
    return (
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="flex-end"
      >
        {cells}
      </Grid>
    );


  };
}